import React, { Fragment, useEffect, useState } from "react";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import TeamSection from "../../components/TeamSection/TeamSection";
import Footer from "../../components/footer/Footer";
import CtaSection from "../../components/ctaSection/ctaSection";
import Navbar2 from "../../components/Navbar2/Navbar2";
import img from "../../images/contact.jpg";
import { getTeams } from "../../api/team";
import StarLoader from "../../components/loader/StarLoader";

const TeamPage = () => {
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const data = await getTeams();
        setTeams(data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  if (loading) {
    return <StarLoader />;
  }

  return (
    <Fragment>
      <Navbar2 hclass={"wpo-header-style-1"} />
      <PageTitle pageTitle={"Team Members"} pagesub={"team"} img={img} />
      <TeamSection teams={teams} tClass={"wpo-team-section-s3"} />
      <CtaSection />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default TeamPage;
